import gql from "graphql-tag";

// import { fragmentUser } from "@saleor/fragments/auth";
import { TypedMutation } from "../mutations";
import { BrandCreate, BrandCreateVariables } from "./types/BrandCreate";
import { BrandUpdate, BrandUpdateVariables } from "./types/BrandUpdate";
export const BrandCreate_ = gql`
  mutation BrandCreate($input: BrandCreateInput!) {
    brandCreate(input: $input) {
      brand {
        id
        name
        legalName
        code
        accountManager {
          id
          email
          firstName
          lastName
        }
        completeAddress
        vendorId
        mobileNo
        status
        tinNo
        signatoryName
        signatoryEmail
        signatoryDesignation
        signatoryMobileNo
        bankName
        bankAccountName
        bankAccountNo
        financeName
        financeEmail
        financeMobileNo
        storeType
        sellerId
      }
      errors: brandErrors {
        field
        message
        code
      }
    }
  }
`;
export const BrandCreateMutation = TypedMutation<
  BrandCreate,
  BrandCreateVariables
>(BrandCreate_);

export const BrandUpdate_ = gql`
  mutation BrandUpdate($id: ID!, $input: BrandUpdateInput!) {
    brandUpdate(id: $id, input: $input) {
      brand {
        id
        name
        legalName
        code
        accountManager {
          id
          email
          firstName
          lastName
        }
        completeAddress
        vendorId
        mobileNo
        status
        tinNo
        signatoryName
        signatoryEmail
        signatoryDesignation
        signatoryMobileNo
        bankName
        bankAccountName
        bankAccountNo
        financeName
        financeEmail
        financeMobileNo
        storeType
        sellerId
      }
      errors: brandErrors {
        field
        message
        code
      }
    }
  }
`;
export const BrandUpdateMutation = TypedMutation<
  BrandUpdate,
  BrandUpdateVariables
>(BrandUpdate_);
